import { useEffect } from "react";
import { useIntl } from "react-intl";
import { Form, Row, Col, Button } from "antd";
import ChildrenAnimationWrapper from "../../../animations/ChildrenAnimationWrapper";
import AnimationChildWrapper from "../../../animations/AnimationChildWrapper";
import RadioButtonItem from "../../../forms/RadioButtonItem";
import { SettingsDataSelect } from "../../../forms/AutoCompleteFormItem";
import {
  useCrm_task_statuses,
  useCrm_task_priorities,
} from "../../../../hooks";

const ToDoFilters = (props) => {
  const { changeContentTitle, filters, changeFilters } = props;
  const intl = useIntl();
  const [form] = Form.useForm();
  const statuses = useCrm_task_statuses();
  const priorities = useCrm_task_priorities();

  useEffect(() => {
    if (statuses.length > 0) {
      onReset();
    }
  }, [statuses]);

  useEffect(() => {
    if (filters.due_date) {
      let due_date = "all";
      switch (filters.due_date) {
        case "all":
          due_date = "all";
          break;
        case "lastTwoWeeks":
          due_date = "lastTwoWeeks";
          break;
        case "today":
          due_date = "today";
          break;
        case "nextWeek":
          due_date = "nextWeek";
          break;
        case "overdue":
          due_date = undefined;
          break;
        default:
          break;
      }
      form.setFieldValue("due_date", due_date);
      if (filters.due_date === "overdue" && filters.status !== undefined) {
        form.setFieldValue("status", undefined);
        changeFilters("status", {
          ...filters,
          status: undefined,
        });
      }
    }
  }, [filters]);

  useEffect(() => {
    const arr = [];
    const statusName =
      filters.status &&
      statuses &&
      statuses.length > 0 &&
      statuses.filter((i) => i.id === filters.status)[0].name;
    const priorityName =
      filters.priority &&
      priorities &&
      priorities.length > 0 &&
      priorities.filter((i) => i.id === filters.priority)[0].name;
    if (filters.priority) {
      arr.push(
        `${intl.formatMessage({
          id: "app.forms.todolist.priority",
        })}: ${intl.formatMessage({
          id: `app.dataSelect.priority.${priorityName}`,
        })}`
      );
    }
    if (filters.status) {
      arr.push(
        `${intl.formatMessage({
          id: "app.forms.todolist.status",
        })}: ${intl.formatMessage({
          id: `app.dataSelect.status.${statusName}`,
        })}`
      );
    }
    if (filters.due_date) {
      arr.push(
        `${intl.formatMessage({
          id: "app.forms.todolist.due_date",
        })}: ${intl.formatMessage({
          id: `app.dataSelect.due_date.${filters.due_date}`,
        })}`
      );
    }

    changeContentTitle(arr);
  }, [filters]);

  const onValuesChange = (values, all) => {
    changeFilters(values, all);
  };

  const onFinish = async (values) => {};

  const onFinishFailed = (errorInfo) => {
    console.log("Failed:", errorInfo);
  };

  const onReset = () => {
    const openStatus =
      statuses &&
      statuses.length > 0 &&
      statuses.filter((i) => i.name === "open")[0].id;
    form.setFieldsValue({
      due_date: "all",
      priority: undefined,
      status: openStatus,
    });
    changeContentTitle([]);
    changeFilters(
      { due_date: "all" },
      {
        due_date: "all",
        priority: undefined,
        status: openStatus,
      }
    );
  };

  return (
    <div>
      <Form
        scrollToFirstError
        layout="vertical"
        onFinish={onFinish}
        onFinishFailed={onFinishFailed}
        form={form}
        onValuesChange={onValuesChange}
      >
        <ChildrenAnimationWrapper>
          <Row>
            <Col span={24} style={{ padding: "0 20px" }}>
              <AnimationChildWrapper key={1} itemKey={1}>
                <SettingsDataSelect
                  category={"todolist"}
                  name="priority"
                  settingsdataName={"system_tables/crm/crm_task_priorities"}
                  style={{ width: "100%" }}
                />
              </AnimationChildWrapper>
              <AnimationChildWrapper key={2} itemKey={2}>
                <SettingsDataSelect
                  category={"todolist"}
                  name="status"
                  settingsdataName={"system_tables/crm/crm_task_statuses"}
                  style={{ width: "100%" }}
                  disabled={filters.due_date === "overdue"}
                />
              </AnimationChildWrapper>

              <AnimationChildWrapper key={3} itemKey={3}>
                <RadioButtonItem
                  name="due_date"
                  category="todolist"
                  todoDueDate={true}
                  translated={true}
                />
              </AnimationChildWrapper>
              <AnimationChildWrapper key={4} itemKey={4}>
                <Button onClick={onReset}>
                  {intl.formatMessage({
                    id: "app.actions.reset_filters",
                  })}
                </Button>
              </AnimationChildWrapper>
            </Col>
          </Row>
        </ChildrenAnimationWrapper>
      </Form>
    </div>
  );
};

export default ToDoFilters;
